import React from 'react';
import { StyleSheet, View, Button, Text, TouchableOpacity } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { Pages } from '../models/enums';
import { useSelector } from 'react-redux';
import { Regions } from '../models/regions';

export default () => {
    const navigation = useNavigation();
    const app = useSelector((state) => state.app);
    const region = Regions.getRegionByCode(app.region);

    return (
        <View style={styles.container}>
          <TouchableOpacity onPress={() => navigation.navigate(Pages.regions)}>
              <Text style={styles.heading1}>{!!region && region.name}</Text>
            </TouchableOpacity>
        </View>
    );
  }
  
  const styles = StyleSheet.create({
    container: {
      padding: 5,
      display: 'flex',
      flexDirection: 'row',
      backgroundColor: '#140b26',
      alignItems: 'center',
      justifyContent: 'center',
      marginTop: 0
    },
    heading1: {
      color: '#aaa',
      fontSize: 30,
      margin: 20
    }
  });
  